import { render, staticRenderFns } from "./a-loading.vue?vue&type=template&id=71aed6d2"
import script from "./a-loading.vue?vue&type=script&lang=js"
export * from "./a-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports